import axios from "axios";
import toasty from "./toasty.util";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import MESSAGE from "../constants/message.constant";
import { useEffect } from "react";
import { downloadFileUsingUrl } from "./file-save.util";
import { PLACE_HOLDERS } from "../constants/template.constant";

const getBrowserName = () => {
    const userAgent = navigator.userAgent;

    if (/Firefox/i.test(userAgent)) {
        return 'Mozilla Firefox';
    }

    if (/Edg/i.test(userAgent)) {
        return 'Microsoft Edge';
    }

    if (/OPR|Opera/i.test(userAgent)) {
        return 'Opera';
    }

    if (/Chrome/i.test(userAgent) && !/Edg/i.test(userAgent)) {
        return 'Google Chrome';
    }

    if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
        return 'Apple Safari';
    }

    if (/MSIE|Trident/i.test(userAgent)) {
        return 'Internet Explorer';
    }

    return 'Unknown Browser';
};

export const ACCEPT_LANGUAGE = navigator.language;

const fetchIpAddress = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Error fetching IP address:', error);
        return 'Unavailable';
    }
};

const navigateTo = (value) => {
    window.location.href = value
}

const reload = () => {
    if (window.electronAPI) window.electronAPI.reloadMainWindow()
    else window.location.reload()
}

const getPresignedUrl = async (filePath) => {
    const { data } = await axios.get(`/api/common/presigned-url`, { params: { filePath: filePath } });
    return data.url;
}

function getCardType(number) {
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null) return "Visa";

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (
        /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
            number
        )
    )
        return "Mastercard";

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null) return "AMEX";

    // Discover
    re = new RegExp(
        "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
    );
    if (number.match(re) != null) return "Discover";

    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null) return "Diners";

    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null) return "Diners - Carte Blanche";

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null) return "JCB";

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null) return "Visa Electron";

    return "";
}
const getContentByUrl = async (preSignedUrl) => {
    try {
        const { data: { content } } = await axios.get('/api/common/template-content-by-presigned', { params: { url: preSignedUrl } });
        return content;
    } catch (error) { }
};

const replaceTemplatePlaceholders = async (clientId, lead, template, options = {}) => {
    try {
        const [clientRes, customFieldRes] = await Promise.all([
            axios.get(`/api/common/client-info-for-template`, { params: { clientId } }),
            lead?.id
                ? axios.get(`/api/client/custom-fields-values`, {
                    params: { clientId, leadId: lead.id }
                })
                : Promise.resolve(null)
        ]);

        const obj = { ...clientRes.data };
        const customFields = customFieldRes?.data;

        // Merge lead data
        if (lead && Object.keys(lead).length) {
            Object.assign(obj, {
                FName: lead.firstName,
                LName: lead.lastName,
                StreetAddress: lead.address,
                City: lead.city,
                State: lead.state,
                ZipCode: lead.zipCode,
                Phone: lead.phoneNumber,
                CompanyName: lead.companyName,
                Email: lead.email,
                TypeOfLoan: lead.typeOfLoan,

                SalesRepFName: lead.clientLoFirstName || '',
                SalesRepLName: lead.clientLoLastName || '',
                SalesRepEmail: lead.clientLoEmail || '',
                SalesRepMobile: lead.clientLoMobileNumber || '',
                SalesRepPhone: lead.clientLoPhoneNumber || '',

                EPODate: formatDate(lead.epoDate),
                ClosingDate: formatDate(lead.closingDate),
                DOB: formatDate(lead.dob),
                CalendarLink: options?.calendarLink?.calenderLink || ''
            });
        }

        // Add custom fields
        if (customFields) {
            Object.entries(customFields).forEach(([key, value]) => {
                const formattedKey = key
                    .split(' ')
                    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                    .join('');

                obj[formattedKey] = value ?? '';
            });
        }
        obj.CurrentDate = moment().format('MM-DD-YYYY');

        // Object.keys(obj).forEach(key => { template = template.split('{{' + key + '}}').join(obj[key] && typeof obj[key] == 'string' ? obj[key].replace(/null|undefined/g, '') : '')})

        // Replace placeholders efficiently
        return template.replace(/\{\{(.*?)\}\}/g, (_, key) => {
            const value = obj[key];
            return typeof value === 'string'
                ? value.replace(/null|undefined/g, '')
                : value ?? '';
        });

    } catch (error) {
        toasty.error(error?.response?.data?.message || MESSAGE.SOMETHING_WRONG);
        return template;
    }
};

const getCurrentTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const formatDate = (date, format = 'MM-DD-YYYY', currentTimeZone = getCurrentTimeZone()) => date ? momentTimeZone.tz(date, currentTimeZone).format(format) : '';

const downloadFile = (url) => {

    if (!url) {
        toasty.error("File not ready yet. Please try again.");
        return;
    }

    try {
        downloadFileUsingUrl(url)
    } catch (error) {
        toasty.error("Failed to download sheet");
        console.error(error);
    }
};

const useClickOutside = (ref, callback) => {
    useEffect(() => {
        const handler = (event) => {
            if (!ref?.current || ref.current.contains(event.target)) return;
            callback();
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [ref, callback]);
};

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const delay = (callback, time = 500) => setTimeout(callback, time);

const getDatabaseInfoByDatabaseId = async (databaseId) => {
    try {
        const { data: { database } } = await axios.get(`/api/client/database-info`, { params: { databaseId } });
        return database;
    } catch (error) {
        console.error('Error fetching database info:', error);
    }
}


const restorePlaceholders = (html) => {

    const placeholderMap = Object.fromEntries(
        PLACE_HOLDERS.map(item => [item.text, item.name])
    );

    const updatedHtml = html.replace(/\{\{[^}]+\}\}/g, (match) => {
        const label = placeholderMap[match] || match;

        return `<span spellcheck="false" contenteditable="false" data-id="${match}">${label}</span>`;
    });

    return updatedHtml;
}

const restorePlaceholdersWithCss = (html) => {

    const placeholderMap = Object.fromEntries(
        PLACE_HOLDERS.map(item => [item.text, item.name])
    );

    const updatedHtml = html.replace(/\{\{[^}]+\}\}/g, (match) => {
        const label = placeholderMap[match] || match;

        return `<span class="placeholder-tag" spellcheck="false" contenteditable="false" data-id="${match}">${label}</span>`;
    });

    return updatedHtml;
}

const waitForImage = (url, retries = 10, delay = 500) =>
    new Promise((resolve, reject) => {
      const check = () => {
        const img = new Image();

        img.onload = () => resolve(url);

        img.onerror = () => {
          if (retries-- <= 0) {
            reject(new Error("Image not found"));
          } else {
            setTimeout(check, delay);
          }
        };

        img.src = `${url}&t=${Date.now()}`;
      };
      check();
    }
  );

export {
    getBrowserName,
    getPresignedUrl,
    getContentByUrl,
    replaceTemplatePlaceholders,
    fetchIpAddress,
    reload,
    navigateTo,
    getCardType,
    getCurrentTimeZone,
    downloadFile,
    formatDate,
    useClickOutside,
    wait,
    delay,
    getDatabaseInfoByDatabaseId,
    restorePlaceholders,
    restorePlaceholdersWithCss,
    waitForImage
}